import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    betaLabelTypography: {
        color: "var(--blueGrey-600, #546E7A)",
        fontFeatureSettings: "'liga' off, 'clig' off",
        fontFamily: "Inter",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "157 %" /* 21.98px */,
        letterSpacing: "0.1px",
    },
    bookClosureTabContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "var(--8, 8px)",
    },
    chipStyleBeta: {
        display: "flex",
        padding: "2px 8px",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        borderRadius: "72px",
        background: "var(--blueGrey-100, #CFD8DC)",
    },
    tabLabelTypography: {
        fontFamily: "Inter",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "24px",
        letterSpacing: "0.4px",
    },
    tabLabelColor: {
        color: "unset !important",
    }
}))
